import Check from 'svg/Check';
import classNames from 'styles/utils/classNames';

interface Props {
  checked: boolean;
  /** `sm` = 16px (dropdown rows), `md` = 20px (request rows). */
  size?: 'sm' | 'md';
}

/** The design system's square checkbox, as a visual only; the row around it is the control. */
export default function CheckboxMark({ checked, size = 'sm' }: Props) {
  return (
    <span
      className={classNames(
        'flex shrink-0 items-center justify-center rounded border',
        size === 'md' ? 'h-5 w-5' : 'h-4 w-4',
        checked
          ? 'border-color-bg-lightmode-invert bg-color-bg-lightmode-invert text-color-text-lightmode-invert dark:border-color-bg-darkmode-invert dark:bg-color-bg-darkmode-invert dark:text-color-text-darkmode-invert'
          : 'border-color-border-input-lightmode bg-color-bg-lightmode-primary dark:border-color-border-input-darkmode dark:bg-color-bg-darkmode-primary',
      )}
    >
      {checked && <Check className={size === 'md' ? 'h-4 w-4' : 'h-3 w-3'} />}
    </span>
  );
}
